/* eslint no-console: "error" */
import React, { FC, useEffect, useRef, useState } from 'react'
import {
	Callback,
	DadataIpAddress,
	OrderCreateParams,
	OrderCreateParamsWithFile,
	OrderModel,
	PartnerInfo,
	Region,
	LeadCreate,
} from 'Pages/landings/newLandings/common/types'
import {
	getParamsFromUrl,
	getQuery,
	submitLeadAndOrder,
	submitOrder,
} from 'Pages/landings/newLandings/common/helpers'
import { useChannels, useProducts } from 'Pages/landings/newLandings/common/hooks'
import {
	LEAD_ERROR_CODE,
	OutLinks,
	PrefixChannel,
	urls,
	ProductNames,
} from 'Pages/landings/newLandings/common/constants'
import { landingApi } from 'Pages/landings/newLandings/common/api'
import { ButtonComponent, ModalComponent } from 'Pages/landings/newLandings/common/components'
import { SmsFormComponent } from 'Pages/landings/newLandings/products/rboPage/ModalSmsForm'
import { PartnerNames } from 'Pages/landings/newLandings/multilanding/common'
import { ModalText, ModalTextHref } from './styled'

interface ComponentProps {
	type: string
	measure: string
	text: string
	formValue: OrderCreateParamsWithFile
	submit: Callback
	orderID: number
	goBack?: Callback
	className?: string
	isProduct?: boolean
	agreement?: PartnerInfo
	needConfirmPhone?: boolean
	changeLoading?: () => void
	isLoading?: boolean
}

export const SubmitComponent: FC<ComponentProps> = ({
	type,
	measure,
	text,
	formValue,
	submit,
	orderID,
	goBack,
	className,
	isProduct = false,
	needConfirmPhone = false,
	changeLoading,
	isLoading,
}) => {
	const [lead, setLead] = useState(null)
	const [isShowModalSms, setIsShowModalSms] = useState(false)
	const changeShowModalSms = () => setIsShowModalSms(!isShowModalSms)
	const { sendPostbackExternalForm, getIp, getDadataAddressByIp, getRegions, getOrderBuild } =
		landingApi
	const regionName = useRef<string | null>(null)
	const id = getQuery()?.partnerID
	const { products } = useProducts(id)
	const clickId = getQuery()?.click_id
	const product = getQuery()?.product
	const partner = getQuery()?.partner
	const { channel } = useChannels(PrefixChannel[product])

	const getProductId = () => {
		if (product === ProductNames.RBO) {
			const nbss = products?.find((item) => item.slug === 'nbss')
			if (nbss) {
				return [nbss?.id]
			}
		}
		if (product === ProductNames.RKO) {
			const legkiyStart = products?.find((item) => item.slug === 'sberbiznes-praym')
			if (legkiyStart) {
				return [legkiyStart?.id]
			}
		}
		if (partner === PartnerNames.FRANCHISE) {
			return products?.filter((item) => item.slug !== 'nbss').map((product) => product.id)
		}

		return products?.map((product) => product.id)
	}

	const [modalText, setModalText] = useState<string>('')
	const [region, setRegion] = useState<Region>(null)

	useEffect(() => {
		const mainCallBack = (regions: Region[]) => {
			getIp()
				.then(getDadataAddressByIp)
				.then((address: DadataIpAddress) => {
					const nameRegion = address.location?.data.region || ''
					const nameRegionType = address.location?.data.region_type_full || ''
					const name = `${nameRegion} ${nameRegionType}`.toLocaleLowerCase().trim()
					const findRegion = regions.find((region) => region.name.toLocaleLowerCase() === name)
					setRegion(findRegion)
					regionName.current = findRegion.name
				})
		}
		getRegions().then((response) => {
			if (response?.entries) mainCallBack(response.entries)
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleSubmit = async (applyLeadSms?: boolean) => {
		if (changeLoading) changeLoading()
		if (id === null || id === undefined) {
			if (changeLoading) changeLoading()
			setModalText('Заявка не создана: Некорректная ссылка')
			return false
		}
		const callback = (res: OrderModel | LeadCreate) => {
			if (changeLoading) changeLoading()
			if (needConfirmPhone && !applyLeadSms) {
				setLead(res)
				setIsShowModalSms(true)
			} else {
				if (window.location.href.includes(urls.landings.selfEmployed)) {
					return setModalText('Заявка создана:В ближайшее время с вами свяжется специалист банка')
				}
				if (window.location.href.search(urls.landings.notary)) {
					if (isProduct) {
						if (product === ProductNames.RBO) {
							return setModalText(
								'Заявка создана:В ближайшее время с вами свяжется специалист банка'
							)
						}
						return setModalText('Заявка создана:Ожидайте СМС')
					}
					return setModalText('Заявка создана')
				}
				setModalText('Заявка создана успешно:Спасибо, мы свяжемся с клиентом в ближайшее время!')

				if (clickId) {
					const {
						partner: { vat_number },
						number,
					} = res as unknown as OrderModel
					if (OutLinks.postback[vat_number]) sendPostbackExternalForm(clickId, number, vat_number)
				}
			}
		}

		const errorCallback = (data) => {
			if (changeLoading) changeLoading()
			const keys = Object.keys(data[0] ?? {})
			const error = Object.keys(data[0] ?? {})[0]
			if (keys.includes(LEAD_ERROR_CODE.SMS_TIMER)) {
				const timer = new Date(data[0][LEAD_ERROR_CODE.SMS_TIMER])
				setLead({
					...lead,
					sms_created_at: new Date(timer.setMinutes(timer.getMinutes() - 3)),
				})
				setIsShowModalSms(true)
			} else {
				switch (error) {
					case 'blocked_by_me':
						if (isProduct)
							return setModalText(
								`Ошибка при отправке:Ваша заявка уже в работе. Если у вас остались вопросы, 
							обратитесь в службу поддержки по номеру 0321`
							)
						return setModalText(
							'Заявка не создана:Заявка по этому ИНН уже создана. Обратитесь в службу поддержки :support@dasreda.ru'
						)
					case 'blocked_by_other':
						if (isProduct)
							return setModalText(`Заявка не создана:Заявка по данному ИНН уже заведена`)
						return setModalText('Заявка по данному ИНН уже заведена')
					default:
						if (isProduct)
							return setModalText(
								`Ошибка при отправке:Заявка не создана по прочим причинам. 
								Для уточнения обратитесь на support@dasreda.ru`
							)
						return setModalText(
							'Заявка не создана:Продукт не соответствует заявленному. Обратитесь в ' +
								'службу поддержки :support@dasreda.ru'
						)
				}
			}
		}

		const product_ids = products?.map((product) => product.id)
		const { file, ...formValueInOrder } = formValue
		const paramsOrder: OrderCreateParams = {
			...formValueInOrder,
			product_ids: isProduct ? getProductId() : product_ids,
			last_name: formValueInOrder.last_name ?? '.',
			region_id: region?.id,
			channel_id: channel?.id,
			...getParamsFromUrl(),
		}

		const submitFunction = applyLeadSms ? submitOrder : submitLeadAndOrder

		const executeSubmission = () => {
			submitFunction(
				orderID,
				paramsOrder,
				id,
				regionName.current,
				callback,
				errorCallback,
				file,
				needConfirmPhone
			)
		}

		if (isProduct) {
			const buildData = {
				...getParamsFromUrl(),
				inn: formValue.inn,
			}

			getOrderBuild(id, buildData)
				.then(executeSubmission)
				.catch(() => {
					if (changeLoading) changeLoading()
					setModalText(
						`Ошибка при отправке: Заявка не создана по прочим причинам. 
           Для уточнения обратитесь на support@dasreda.ru`
					)
				})
		} else {
			executeSubmission()
		}
	}

	const closeModal = () => {
		setModalText('')
		if (window.location.href.search('/landing/notary')) goBack()
	}

	return (
		<>
			{isShowModalSms && (
				<ModalComponent
					isScroll={isShowModalSms}
					closeModal={changeShowModalSms}
					title="Подтверждение номера"
					hiddenBtn
				>
					<SmsFormComponent
						lead={lead}
						callbackCreateOrder={() => {
							submit(() => handleSubmit(true))
						}}
						closeModal={changeShowModalSms}
					/>
				</ModalComponent>
			)}
			<ButtonComponent
				className={className}
				type={type}
				measure={measure}
				text={text}
				onClick={() => submit(() => handleSubmit(false))}
				isLoading={isLoading}
				disabled={isLoading}
			/>
			{Boolean(modalText) && (
				<ModalComponent title={modalText.split(':')[0]} closeModal={closeModal} btnType={type}>
					<ModalText>
						{modalText.split(':')[1]}
						{Boolean(modalText.split(':')[2]) && (
							<ModalTextHref>{modalText.split(':')[2]}</ModalTextHref>
						)}
					</ModalText>
				</ModalComponent>
			)}
		</>
	)
}
